import {ControlContainer, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Component, ElementRef, forwardRef, Host, Input, OnInit, Optional, SkipSelf, ViewChild} from '@angular/core';

import {BaseComponent, BaseControl} from '../../classes';

@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TextareaComponent),
        multi: true
    }]
})
export class TextareaComponent extends BaseComponent<string, KeyboardEvent, BaseControl> implements OnInit {
    @ViewChild('input', {static: true}) inputReference: ElementRef;

    @Input() public disabled: boolean;

    constructor(
        @Optional() @Host() @SkipSelf()
        protected controlContainer: ControlContainer
    ) {
        super(controlContainer);
    }

    ngOnInit() {
        this.asFormsControl();
        this.checkInvalid();
    }

    changeValue(event: KeyboardEvent | ClipboardEvent): void {
        let value = '';

        if (event instanceof KeyboardEvent) {
            value = (event.target as HTMLInputElement).value;
        }

        if (event instanceof ClipboardEvent) {
            const clipboardData = event.clipboardData;

            value = clipboardData.getData('text');
        }

        this.onChange(value);
        this.checkInvalid();
        this.control.resetErrors();

        super.writeValue(value);
    }

    writeValue(value: string): void {
        this.inputReference.nativeElement.value = value;
        this.checkInvalid();
        this.control.resetErrors();

        super.writeValue(value);
    }

    asFormsControl(): BaseControl {
        if (!this.control) {
            this.control = new BaseControl({
                name: '',
                value: '',
                placeholder: '',
                validators: [],
                componentType: 0,
                invalid: false,
                errors: []
            });
        }

        return this.control;
    }
}
